import { defineComponent as o, openBlock as t, createBlock as r, Teleport as s, renderSlot as a } from "vue";
import { _ as d } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const n = o({
  name: "OrTeleport",
  props: {
    to: {
      type: String,
      default: "body"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }
});
function p(e, l, f, i, c, m) {
  return t(), r(s, {
    to: e.to,
    disabled: e.disabled
  }, [
    a(e.$slots, "default")
  ], 8, ["to", "disabled"]);
}
const b = /* @__PURE__ */ d(n, [["render", p]]);
export {
  b as O
};
//# sourceMappingURL=OrTeleport.vue3-C9kW_8PS.mjs.map
